/**
 * AlphaSense Agent - Tools Section
 *
 * Standard tools section with preamble and postamble from Keywords AI.
 */
import { PromptSectionBase } from '../../../base/systemPrompt/PromptSectionBase';
import { ALPHASENSE_PROMPT_KEYS } from './variables';
/**
 * Tools preamble - introduction to available tools
 */
class AlphaSenseToolsPreambleSection extends PromptSectionBase {
    constructor() {
        super(...arguments);
        this.keywordsKey = ALPHASENSE_PROMPT_KEYS.toolsPreamble;
        this.fallbackContent = `## Available Tools

You have access to the searchAlphaSense tool for researching financial data.`;
    }
}
/**
 * Tools postamble - closing guidance
 */
class AlphaSenseToolsPostambleSection extends PromptSectionBase {
    constructor() {
        super(...arguments);
        this.keywordsKey = ALPHASENSE_PROMPT_KEYS.toolsPostamble;
        this.fallbackContent = `**Instructions:**
1. Analyze ALL requirements upfront
2. Formulate ALL search queries needed across all requirements
3. Call searchAlphaSense ONCE with all queries in the queries array
4. Review results, make additional batch searches if needed
5. When satisfied, call submitResults with your findings`;
    }
}
const toolsPreambleSection = new AlphaSenseToolsPreambleSection();
const toolsPostambleSection = new AlphaSenseToolsPostambleSection();
/**
 * Export constants for backwards compatibility
 */
export const ALPHASENSE_TOOLS_PREAMBLE = toolsPreambleSection.getFallbackContent();
export const ALPHASENSE_TOOLS_POSTAMBLE = toolsPostambleSection.getFallbackContent();
/**
 * Get the tools preamble.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getToolsPreamble() {
    return toolsPreambleSection.getContent();
}
/**
 * Get the tools postamble.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getToolsPostamble() {
    return toolsPostambleSection.getContent();
}
// ═══════════════════════════════════════════════════════════════════════════
// TOOLS SECTION BUILDER
// ═══════════════════════════════════════════════════════════════════════════
export function buildToolsSection(tools) {
    const parts = [];
    // 1. Preamble
    parts.push(getToolsPreamble());
    parts.push('');
    // 2. Individual tool descriptions
    for (const tool of tools) {
        parts.push(tool.systemPromptDescription);
        parts.push('');
    }
    // 3. Postamble
    parts.push(getToolsPostamble());
    return parts.join('\n');
}
